import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button, Textarea } from "@mui/joy";
import { postFetch } from "../../../../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./callhistory.module.css";
import { formatPhone } from "./callhistoryformat";

const toastOptions : any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored"
};

//"처리됨으로 표시" — 처리 이유 입력(필수) 후 저장. 좌측 표는 "부재중 N분_수동처리" 로 바뀌고 메모는 마지막 부재중 행에 붙는다
const CallbackDoneModal : React.FC<any> = (props) => {

    const [reason, setReason] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [submitting, setSubmitting] = useState<boolean>(false);

    useEffect(() => {
        if (props.open) {
            setReason("");
            setError("");
            setSubmitting(false);
        }
    }, [props.open]);

    const c = props.contact;
    if (!c) {
        return null;
    }

    const submit = async () => {
        const text = reason.trim();
        if (!text) {
            setError("처리 이유를 입력해주세요");
            return;
        }
        if (text.length > 500) {
            setError("500자 이내로 입력해주세요");
            return;
        }
        setSubmitting(true);
        setError("");
        try {
            const result : any = await postFetch("/dashboard/callcenter/history/contacts/callbackDone", {
                phone: c.phoneNumber,
                reason: text
            });
            if (result.message === "success") {
                toast.success("처리됨으로 표시했습니다", toastOptions);
                props.onDone(result.contact);
                props.onClose();
            } else if (result.message === "noReason") {
                setError("처리 이유를 입력해주세요");
            } else {
                setError("저장에 실패했습니다");
            }
        } catch (e) {
            console.log(e);
            setError("저장에 실패했습니다");
        }
        setSubmitting(false);
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "380px" }}>
                    <div className={styles.modalTitle}>처리됨으로 표시</div>
                    <div style={{ fontSize: "13.5px", lineHeight: 1.5, color: "#4B5563" }}>
                        <b>{c.displayName || formatPhone(c.phoneNumber)}</b> ({formatPhone(c.phoneNumber)}) 의 콜백을 수동으로 처리합니다.<br />
                        이후 이 번호와 통화가 연결되면 수동처리 표시는 자동으로 사라집니다.
                    </div>

                    <div className={styles.modalLabel}>처리 이유</div>
                    <Textarea
                        minRows={3}
                        value={reason}
                        placeholder="예: 문자로 안내 완료 / 타 지점에서 응대 / 스팸"
                        onChange={(e) => setReason(e.target.value)}
                        slotProps={{ textarea: { autoFocus: true, maxLength: 500 } }}
                    />
                    {
                        error ?
                            <div className={styles.modalError}>{error}</div>
                            :
                            ""
                    }

                    <div className={styles.modalButtons}>
                        <Button variant="plain" color="neutral" onClick={props.onClose} disabled={submitting}>취소</Button>
                        <Button variant="solid" color="neutral" onClick={submit} loading={submitting} disabled={!reason.trim()}>저장</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default CallbackDoneModal;
